import apiClient from './apiClient';

export interface QueryParams {
  order_no_from?: string;
  order_no_to?: string;
  date_from?: string;       // YYYY-MM-DD
  date_to?: string;         // YYYY-MM-DD
  product_from?: string;
  product_to?: string;
  category?: number;        // 1=原物料, 2=托工, 3=全部, 4=代工入布
}

export interface MovementRow {
  batch_id: string;          // 批號識別碼 (12碼)
  color_name: string;        // 顏色名稱
  inbound_qty: number;       // 入庫量
  doc_no: string;            // 單據號碼
  movement_type: string;     // 單據種類 (交運/領用/...)
  location_name: string;     // 庫位名稱
  doc_date: string;          // 單據日期
  qty: number;               // 使用量
  balance: number;           // 結存
}

export interface Summary {
  total_inbound: number;
  total_outbound: number;
  total_balance: number;
  batch_count: number;
  movement_count: number;
}

export interface QueryResponse {
  data: MovementRow[];
  count: number;
  summary: Summary;
  message?: string;
}

export const d312Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d312/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d312/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
